import french from './strings_fr'

export const languages = [{name: 'french', code: 'fr'}];

export const strings = {
  french,
};